import React from "react";

export default ({ children }) => <div className="modal-body p-5">{children}</div>;
